import { CommonModule } from "@angular/common";
import { Component, OnDestroy, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { NotificationsService, NotificationPayload } from "../../services/notifications.service";
import { PopupComponent } from "../popup/popup.component";

@Component({
    selector: "clp-notification-host",
    standalone: true,
    templateUrl: "./notification-host.component.html",
    styleUrls: ["./notification-host.component.scss"],
    imports: [CommonModule, TranslateModule, PopupComponent],
})
export class NotificationHostComponent implements OnDestroy {
    notification: NotificationPayload | null = null;
    showModal = false;
    private notificationsService = inject(NotificationsService);
    private subscription: Subscription;

    constructor() {
        this.subscription = this.notificationsService.notifications$.subscribe((payload) => {
            this.notification = payload;
            this.showModal = !!payload;
        });
    }

    close(): void {
        this.notificationsService.clear();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
